(function () {
  'use strict';

  var overlay    = document.getElementById('hvac-email-overlay');
  var openBtns   = document.querySelectorAll('.hvac-email-open-btn');
  var closeBtn   = document.getElementById('hvac-email-close-btn');
  var form       = document.getElementById('hvac-email-form');
  var successMsg = document.getElementById('hvac-email-success');
  var errorMsg   = document.getElementById('hvac-email-error');
  var submitBtn  = document.getElementById('hvac-email-submit');

  if (!overlay || !openBtns.length) return;

  var emailSentForPage = false;

  /* ── custom confirmation modal ──────────────────────────────── */
  var confirmOverlay = document.getElementById('hvac-confirm-overlay');
  var confirmYesBtn  = document.getElementById('hvac-confirm-yes');
  var confirmNoBtn   = document.getElementById('hvac-confirm-no');

  function openConfirm(onYes) {
    if (!confirmOverlay) { if (onYes) onYes(); return; }
    confirmOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (confirmYesBtn) confirmYesBtn.focus();

    function handleYes() { cleanup(); onYes(); }
    function handleNo()  { cleanup(); document.body.style.overflow = ''; }
    function handleKey(e) { if (e.key === 'Escape') { cleanup(); document.body.style.overflow = ''; } }
    function handleBg(e)  { if (e.target === confirmOverlay) handleNo(); }

    function cleanup() {
      confirmOverlay.classList.remove('is-open');
      if (confirmYesBtn) confirmYesBtn.removeEventListener('click', handleYes);
      if (confirmNoBtn)  confirmNoBtn.removeEventListener('click', handleNo);
      document.removeEventListener('keydown', handleKey);
      confirmOverlay.removeEventListener('click', handleBg);
    }

    if (confirmYesBtn) confirmYesBtn.addEventListener('click', handleYes);
    if (confirmNoBtn)  confirmNoBtn.addEventListener('click', handleNo);
    document.addEventListener('keydown', handleKey);
    confirmOverlay.addEventListener('click', handleBg);
  }

  function openModal() {
    if (emailSentForPage) {
      openConfirm(function () {
        overlay.classList.add('is-open');
        document.body.style.overflow = 'hidden';
        if (closeBtn) closeBtn.focus();
      });
      return;
    }
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    /* reset so the modal is fresh for the next product/collection */
    if (form) {
      form.reset();
      form.style.display = '';
    }
    if (successMsg) { successMsg.style.display = 'none'; successMsg.textContent = ''; }
    if (errorMsg)   { errorMsg.style.display   = 'none'; errorMsg.textContent   = ''; }
    if (submitBtn)  { submitBtn.disabled = false; submitBtn.textContent = 'SEND EMAIL'; }
  }

  openBtns.forEach(function (btn) { btn.addEventListener('click', openModal); });
  if (closeBtn) closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeModal();
  });

  /* ── helpers ───────────────────────────────────────────────── */

  function buildFilename(isCollection, collData, d) {
    function sanitize(s) {
      return (s || '').replace(/[\\/:"*?<>|]/g, '').replace(/\s+/g, ' ').trim().substring(0, 100);
    }
    function handleToTitle(handle) {
      return (handle || '').split('-').map(function (w) {
        return w ? w.charAt(0).toUpperCase() + w.slice(1) : '';
      }).join(' ');
    }

    if (isCollection && collData) {
      return sanitize(collData.title) || 'HVACMORE Collection';
    }

    var productName = sanitize(d && d.title || '');

    // Prefer URL collection context: /collections/{handle}/products/{slug}
    var collectionName = '';
    var pathMatch = window.location.pathname.match(/\/collections\/([^\/]+)\/products\//);
    if (pathMatch) {
      collectionName = handleToTitle(pathMatch[1]);
    } else {
      // Fall back to breadcrumb (last non-Home, non-active link)
      var crumbLinks = document.querySelectorAll('nav.meta-breadcrumbs a:not(.active-breadcrumb)');
      for (var ci = crumbLinks.length - 1; ci >= 0; ci--) {
        var text = (crumbLinks[ci].textContent || '').trim();
        if (text && text.toLowerCase() !== 'home') { collectionName = sanitize(text); break; }
      }
    }

    return collectionName ? collectionName + ' - ' + productName : productName || 'HVACMORE Product';
  }

  function getProductData() {
    var el = document.getElementById('hvac-product-print-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function esc(s) {
    return (s || '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function getSpecsHtml(d) {
    var src = (d && d.specs_html || '').trim();
    if (src) return src;
    var tabs = document.querySelectorAll('.product-tabs__main li[data-title]');
    for (var i = 0; i < tabs.length; i++) {
      if (/spec/i.test(tabs[i].getAttribute('data-title'))) {
        var rte = tabs[i].querySelector('.rte');
        if (rte) return rte.innerHTML.trim();
      }
    }
    return '';
  }

  /* ── collection page helpers ────────────────────────────────── */

  function isCollectionPage() {
    return !!document.querySelector('.hvac-email-open-btn[data-handle]');
  }

  function getCollectionData() {
    var btn = document.querySelector('.hvac-email-open-btn[data-handle]');
    if (!btn) return null;
    return {
      handle: btn.dataset.handle || '',
      title:  btn.dataset.title  || '',
      logo:   btn.dataset.logo   || ''
    };
  }

  function fetchAllCollectionProducts(handle) {
    var all = [];
    function fetchPage(page) {
      return fetch('/collections/' + handle + '/products.json?limit=250&page=' + page)
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var batch = data.products || [];
          all = all.concat(batch);
          return batch.length === 250 ? fetchPage(page + 1) : all;
        });
    }
    return fetchPage(1);
  }

  function buildCollectionHtml(products, title, logoUrl) {
    function escC(str) {
      return (str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }
    function fmtPrice(p) {
      var n = parseFloat(p);
      if (!n) return 'Contact for price';
      return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    var rows = products.map(function (p) {
      var v = (p.variants && p.variants[0]) || {};
      var tags = typeof p.tags === 'string' ? p.tags.split(', ') : (p.tags || []);
      var originTag = tags.find(function (t) { return /^origin:/i.test(t); });
      var origin  = originTag ? escC(originTag.split(':')[1].trim()) : '';
      var sku     = escC(v.sku || '');
      var vendor  = escC(p.vendor || '');
      var ptitle  = escC(p.title || '');
      var imgSrc  = p.images && p.images[0] ? p.images[0].src.replace(/(\.[^.?]+)(\?.*)?$/, '_120x120$1') : '';
      var price   = fmtPrice(v.price);
      return '<tr>' +
        '<td class="c-img">' + (imgSrc ? '<img src="' + imgSrc + '" alt="' + ptitle + '">' : '') + '</td>' +
        '<td class="c-info">' +
          '<p class="p-name">' + ptitle + '</p>' +
          '<p><b>Brand:</b> ' + (vendor || '&mdash;') + '</p>' +
          (origin ? '<p><b>Origin:</b> ' + origin + '</p>' : '') +
          (sku ? '<p><b>MFG Part:</b> ' + sku + '</p>' : '') +
          '<p><b>Shipping:</b> Free Shipping</p>' +
        '</td>' +
        '<td class="c-sku">' + (sku ? '<b>PART</b> ' + sku : '') + '</td>' +
        '<td class="c-price">' + price + '</td>' +
        '</tr>';
    }).join('');
    return '<!DOCTYPE html><html><head><meta charset="utf-8"><title>' + escC(title) + '</title>' +
      '<style>' +
        '*{box-sizing:border-box;margin:0;padding:0}' +
        'body{font-family:Arial,sans-serif;font-size:12px;color:#111;padding:28px 36px}' +
        '.hdr{margin-bottom:22px}' +
        '.hdr img{max-height:50px;display:block;margin-bottom:14px}' +
        '.hdr h1{font-size:22px;font-weight:700;text-transform:uppercase;letter-spacing:.03em;margin-bottom:6px}' +
        '.hdr p{font-size:13px;font-weight:700}' +
        'table{width:100%;border-collapse:collapse}' +
        'tr{border-top:1px solid #ccc}' +
        'td{padding:12px 8px;vertical-align:top}' +
        '.c-img{width:90px}.c-img img{width:72px;height:72px;object-fit:contain}' +
        '.c-info{width:48%}.p-name{font-size:12px;margin-bottom:6px;line-height:1.4}' +
        '.c-info p{font-size:11px;margin-bottom:2px}' +
        '.c-sku{width:18%;font-size:12px;padding-top:12px}' +
        '.c-price{width:20%;font-size:12px;text-align:right;padding-top:12px}' +
      '</style></head><body>' +
      '<div class="hdr">' +
        '<img src="' + logoUrl + '" alt="HVACMORE">' +
        '<h1>' + escC(title) + '</h1>' +
        '<p>' + products.length + ' Total Products</p>' +
      '</div>' +
      '<table>' + rows + '</table>' +
      '</body></html>';
  }

  function captureCollectionWithHtml2Canvas(html, onDone) {
    if (typeof html2canvas !== 'function') { onDone(null); return; }
    try {
      var PW = 816, PH = 1056;
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:' + PW + 'px;height:' + PH + 'px;border:none;';
      document.body.appendChild(iframe);
      iframe.onload = function () {
        setTimeout(function () {
          var iBody = iframe.contentDocument.body;
          var totalH = Math.max(iBody.scrollHeight, PH);
          iframe.style.height = totalH + 'px';
          html2canvas(iBody, {
            width: PW, height: totalH, windowWidth: PW, windowHeight: totalH,
            useCORS: true, allowTaint: false, scale: 1, logging: false, backgroundColor: '#ffffff'
          }).then(function (canvas) {
            document.body.removeChild(iframe);
            var numPages = Math.ceil(totalH / PH);
            var jpegs = new Array(numPages);
            var done = 0;
            for (var pi = 0; pi < numPages; pi++) {
              (function (idx) {
                var pc = document.createElement('canvas');
                pc.width = PW; pc.height = PH;
                var ctx = pc.getContext('2d');
                ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, PW, PH);
                ctx.drawImage(canvas, 0, idx * PH, PW, PH, 0, 0, PW, PH);
                var b64 = pc.toDataURL('image/jpeg', 0.92).split(',')[1];
                var bin = atob(b64);
                var bytes = new Uint8Array(bin.length);
                for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
                jpegs[idx] = { b: bytes, w: PW, h: PH };
                if (++done === numPages) buildImagePdf(jpegs, onDone);
              })(pi);
            }
          }).catch(function (err) {
            console.error('[hvac-email] collection html2canvas error:', err);
            document.body.removeChild(iframe);
            onDone(null);
          });
        }, 1500);
      };
      var iDoc = iframe.contentDocument || iframe.contentWindow.document;
      iDoc.open(); iDoc.write(html); iDoc.close();
    } catch (e) {
      console.error('[hvac-email] collection capture error:', e);
      onDone(null);
    }
  }

  /* ── native multi-page PDF for collections (no html2canvas needed) ── */

  function generateNativeCollectionPdf(products, title, logoUrl, onDone) {
    var IMG_SZ = 55; /* product thumbnail display size (square) */

    function strToBytes(s) {
      var b = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 0xFF;
      return b;
    }
    function ps(s) {
      return (s || '').replace(/[^\x20-\x7E]/g, '-').replace(/\\/g,'\\\\').replace(/\(/g,'\\(').replace(/\)/g,'\\)');
    }
    function wrap(text, max) {
      var words = (text || '').split(' '), lines = [], line = '';
      for (var wi = 0; wi < words.length; wi++) {
        var w = words[wi]; if (!w) continue;
        if (line && (line + ' ' + w).length > max) { lines.push(line); line = w; }
        else { line = line ? line + ' ' + w : w; }
      }
      if (line) lines.push(line); return lines.length ? lines : [''];
    }
    function fmtP(p) {
      var n = parseFloat(p);
      if (!n) return 'Contact for price';
      return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    function fetchImg(url, maxW, maxH, squareCrop, cb) {
      try {
        var img = new Image(); img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var sw = img.naturalWidth, sh = img.naturalHeight, ox = 0, oy = 0, sw2 = sw, sh2 = sh;
            if (squareCrop) {
              var s = Math.min(sw, sh); ox = (sw-s)/2; oy = (sh-s)/2; sw2 = sh2 = s;
              var dw = Math.min(maxW, maxH), dh = dw;
              var cv = document.createElement('canvas'); cv.width = dw; cv.height = dh;
              var ctx = cv.getContext('2d');
              ctx.fillStyle = '#fff'; ctx.fillRect(0,0,dw,dh);
              ctx.drawImage(img, ox, oy, sw2, sh2, 0, 0, dw, dh);
              var bin = atob(cv.toDataURL('image/jpeg',0.92).split(',')[1]);
              var bytes = new Uint8Array(bin.length);
              for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
              cb(bytes, dw, dh);
            } else {
              var r = Math.min(maxW/sw, maxH/sh, 1);
              var dw2 = Math.max(1, Math.round(sw*r)), dh2 = Math.max(1, Math.round(sh*r));
              var cv2 = document.createElement('canvas'); cv2.width = dw2; cv2.height = dh2;
              var ctx2 = cv2.getContext('2d');
              ctx2.fillStyle = '#fff'; ctx2.fillRect(0,0,dw2,dh2); ctx2.drawImage(img,0,0,dw2,dh2);
              var bin2 = atob(cv2.toDataURL('image/jpeg',0.92).split(',')[1]);
              var bytes2 = new Uint8Array(bin2.length);
              for (var i2 = 0; i2 < bin2.length; i2++) bytes2[i2] = bin2.charCodeAt(i2);
              cb(bytes2, dw2, dh2);
            }
          } catch(e) { cb(null,0,0); }
        };
        img.onerror = function() { cb(null,0,0); };
        img.src = url;
      } catch(e) { cb(null,0,0); }
    }

    function doGenerate(logoB, logoW, logoH, imgMap) {
      try {
        var W = 612, H = 792, ml = 40, mr = 572;
        var hasLogo = !!(logoB && logoB.length);
        var IMG_COL = 65;     /* column width reserved for image */
        var nameX = ml + IMG_COL; /* product-name text starts here */

        /* build ordered list of fetched product images */
        var validImgs = [];       /* [{b,w,h}] in product order */
        var prodImgSeq = {};      /* productIndex -> index in validImgs */
        products.forEach(function(p, idx) {
          if (imgMap[idx]) { prodImgSeq[idx] = validImgs.length; validImgs.push(imgMap[idx]); }
        });

        var allPages = [], cs = [], y = 0;

        function tableHeader() {
          cs.push('0.102 0.235 0.431 rg');
          cs.push(ml + ' ' + (y-3) + ' ' + (mr-ml) + ' 15 re f');
          cs.push('1 1 1 rg');
          cs.push('BT /F2 7.5 Tf ' + (ml+2) + ' ' + y + ' Td (PRODUCT) Tj ET');
          cs.push('BT /F2 7.5 Tf 335 ' + y + ' Td (BRAND) Tj ET');
          cs.push('BT /F2 7.5 Tf 430 ' + y + ' Td (SKU) Tj ET');
          cs.push('BT /F2 7.5 Tf 540 ' + y + ' Td (PRICE) Tj ET');
          y -= 20;
        }

        function startPage(isFirst) {
          cs = []; y = H - 60;
          if (hasLogo) {
            cs.push('1 1 1 rg'); cs.push('0 ' + (H-55) + ' ' + W + ' 55 re f');
            var lDH = Math.min(45, Math.round(logoH * 200 / Math.max(logoW,1)));
            var lDW = Math.round(logoW * lDH / Math.max(logoH,1));
            var lY  = H - 55 + Math.round((55-lDH)/2);
            cs.push('q ' + lDW + ' 0 0 ' + lDH + ' ' + ml + ' ' + lY + ' cm /Lo1 Do Q');
            cs.push('0.102 0.235 0.431 RG 1.5 w');
            cs.push('0 ' + (H-55) + ' m ' + W + ' ' + (H-55) + ' l S');
            cs.push('0 0 0 RG 1 w');
          } else {
            cs.push('0.102 0.235 0.431 rg'); cs.push('0 ' + (H-52) + ' ' + W + ' 52 re f');
            cs.push('1 1 1 rg'); cs.push('BT /F2 14 Tf ' + ml + ' ' + (H-32) + ' Td (HVACMORE) Tj ET');
          }
          y = H - 70;
          if (isFirst) {
            cs.push('0 0 0 rg');
            wrap(title.toUpperCase(), 62).forEach(function(ln) {
              cs.push('BT /F2 13 Tf ' + ml + ' ' + y + ' Td (' + ps(ln) + ') Tj ET'); y -= 17;
            });
            cs.push('0.4 0.4 0.4 rg');
            cs.push('BT /F1 9 Tf ' + ml + ' ' + y + ' Td (' + ps(products.length + ' Total Products') + ') Tj ET');
            y -= 18;
          }
          tableHeader();
        }

        function endPage() {
          cs.push('0.5 0.5 0.5 rg');
          var ft = 'hvacmore.com  |  ' + window.location.href;
          if (ft.length > 80) ft = ft.substring(0,77) + '...';
          cs.push('BT /F1 7 Tf ' + ml + ' 18 Td (' + ps(ft) + ') Tj ET');
          allPages.push(strToBytes(cs.join('\n')));
        }

        startPage(true);

        products.forEach(function(p, idx) {
          var hasImg = prodImgSeq.hasOwnProperty(idx);
          /* narrow the text wrap when an image column is present */
          var tlines = wrap(p.title || '', hasImg ? 34 : 46).slice(0, 3);
          var minRh  = hasImg ? IMG_SZ + 12 : 22;
          var rh     = Math.max(tlines.length * 10 + 8, minRh);
          if (y - rh < 40) { endPage(); startPage(false); }

          var v     = (p.variants && p.variants[0]) || {};
          var sku   = ps((v.sku   || '').substring(0, 20));
          var vndr  = ps((p.vendor|| '').substring(0, 18));
          var price = ps(fmtP(v.price));

          /* alternating row background */
          if (idx % 2 === 0) {
            cs.push('0.961 0.969 0.980 rg');
            cs.push(ml + ' ' + (y-rh+10) + ' ' + (mr-ml) + ' ' + rh + ' re f');
          }

          /* product thumbnail */
          if (hasImg) {
            var si   = prodImgSeq[idx];
            var iDat = validImgs[si];
            var scale = Math.min(IMG_SZ / iDat.w, IMG_SZ / iDat.h);
            var dw   = Math.round(iDat.w * scale);
            var dh   = Math.round(iDat.h * scale);
            /* center image in column, vertically aligned to top-of-row text */
            var ix = ml + Math.round((IMG_SZ - dw) / 2);
            var iy = y - dh + 2;
            cs.push('q ' + dw + ' 0 0 ' + dh + ' ' + ix + ' ' + iy + ' cm /PdIm' + si + ' Do Q');
          }

          /* product name */
          cs.push('0 0 0 rg');
          tlines.forEach(function(ln, li) {
            cs.push('BT /F1 8 Tf ' + (hasImg ? nameX : ml+2) + ' ' + (y-li*10) + ' Td (' + ps(ln) + ') Tj ET');
          });

          /* brand / sku / price */
          cs.push('0.3 0.3 0.3 rg');
          cs.push('BT /F1 8 Tf 335 ' + y + ' Td (' + vndr + ') Tj ET');
          cs.push('BT /F1 7 Tf 430 ' + y + ' Td (' + sku + ') Tj ET');
          cs.push('0.102 0.235 0.431 rg');
          cs.push('BT /F2 8 Tf 540 ' + y + ' Td (' + price + ') Tj ET');

          /* row separator */
          cs.push('0.82 0.82 0.82 RG 0.3 w');
          cs.push(ml + ' ' + (y-rh+10) + ' m ' + mr + ' ' + (y-rh+10) + ' l S');
          cs.push('0 0 0 RG 1 w 0 0 0 rg');
          y -= rh;
        });

        endPage();

        /* ── assemble PDF binary ── */
        var NP       = allPages.length;
        var fontF1N  = 3 + 2*NP;
        var fontF2N  = 4 + 2*NP;
        var loN      = hasLogo ? 5 + 2*NP : 0;
        var imgsBase = (hasLogo ? 6 : 5) + 2*NP;
        var nImgs    = validImgs.length;
        var numObjs  = nImgs > 0 ? imgsBase + nImgs - 1 : (hasLogo ? 5 + 2*NP : 4 + 2*NP);

        /* XObject dictionary covers logo + all product images */
        var xoDict = '';
        if (hasLogo) xoDict += '/Lo1 ' + loN + ' 0 R ';
        for (var vi = 0; vi < nImgs; vi++) xoDict += '/PdIm' + vi + ' ' + (imgsBase+vi) + ' 0 R ';
        var rsrc = '/Font << /F1 ' + fontF1N + ' 0 R /F2 ' + fontF2N + ' 0 R >>'
          + (xoDict.trim() ? ' /XObject << ' + xoDict.trim() + ' >>' : '');

        var parts2 = [], pos2 = 0, offs2 = {};
        function pushStr(s) { var b = strToBytes(s); parts2.push(b); pos2 += b.length; }
        function pushBuf(b) { parts2.push(b); pos2 += b.length; }
        function addObj(n, dict) { offs2[n] = pos2; pushStr(n + ' 0 obj\n' + dict + '\nendobj\n'); }
        function addStm(n, dict, buf) { offs2[n] = pos2; pushStr(n + ' 0 obj\n' + dict + '\nstream\n'); pushBuf(buf); pushStr('\nendstream\nendobj\n'); }

        pushStr('%PDF-1.4\n');
        addObj(1, '<< /Type /Catalog /Pages 2 0 R >>');
        var kids = [];
        for (var pgi = 0; pgi < NP; pgi++) kids.push((3+pgi) + ' 0 R');
        addObj(2, '<< /Type /Pages /Kids [' + kids.join(' ') + '] /Count ' + NP + ' >>');
        for (var pgi2 = 0; pgi2 < NP; pgi2++) {
          addObj(3+pgi2, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + W + ' ' + H + '] /Contents ' + (3+NP+pgi2) + ' 0 R /Resources << ' + rsrc + ' >> >>');
        }
        for (var pgi3 = 0; pgi3 < NP; pgi3++) {
          addStm(3+NP+pgi3, '<< /Length ' + allPages[pgi3].length + ' >>', allPages[pgi3]);
        }
        addObj(fontF1N, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
        addObj(fontF2N, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');
        if (hasLogo) addStm(loN, '<< /Type /XObject /Subtype /Image /Width ' + logoW + ' /Height ' + logoH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + logoB.length + ' >>', logoB);
        for (var ii = 0; ii < nImgs; ii++) {
          var vd = validImgs[ii];
          addStm(imgsBase+ii, '<< /Type /XObject /Subtype /Image /Width ' + vd.w + ' /Height ' + vd.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + vd.b.length + ' >>', vd.b);
        }

        var xp = pos2;
        pushStr('xref\n0 ' + (numObjs+1) + '\n0000000000 65535 f \n');
        for (var n = 1; n <= numObjs; n++) {
          var o = String(offs2[n]); while (o.length < 10) o = '0' + o; pushStr(o + ' 00000 n \n');
        }
        pushStr('trailer\n<< /Size ' + (numObjs+1) + ' /Root 1 0 R >>\nstartxref\n' + xp + '\n%%EOF');

        var total = 0;
        for (var j = 0; j < parts2.length; j++) total += parts2[j].length;
        var result = new Uint8Array(total), rofs = 0;
        for (var j2 = 0; j2 < parts2.length; j2++) { result.set(parts2[j2], rofs); rofs += parts2[j2].length; }

        onDone(new Blob([result], { type: 'application/pdf' }));
      } catch(err) {
        console.error('[hvac-email] native collection PDF error:', err);
        onDone(null);
      }
    }

    /* fetch logo + all product thumbnails in parallel, then build PDF */
    var logoB = null, logoW = 0, logoH = 0;
    var imgMap = {};
    var totalFetch = 1; /* 1 for logo slot */
    var doneFetch  = 0;

    products.forEach(function(p) { if (p.images && p.images[0]) totalFetch++; });

    function checkAllFetched() {
      if (++doneFetch === totalFetch) doGenerate(logoB, logoW, logoH, imgMap);
    }

    if (logoUrl) {
      fetchImg(logoUrl, 600, 150, false, function(b, w, h) { logoB = b; logoW = w; logoH = h; checkAllFetched(); });
    } else {
      checkAllFetched();
    }

    products.forEach(function(p, idx) {
      if (p.images && p.images[0]) {
        var src = p.images[0].src.replace(/(\.[^.?]+)(\?.*)?$/, '_240x240$1');
        (function(pidx, url) {
          fetchImg(url, 240, 240, true, function(bytes, w, h) {
            if (bytes) imgMap[pidx] = { b: bytes, w: w, h: h };
            checkAllFetched();
          });
        })(idx, src);
      }
    });
  }

  function generateCollectionPdf(collData, onDone) {
    submitBtn.textContent = 'Fetching products…';
    fetchAllCollectionProducts(collData.handle)
      .then(function (products) {
        submitBtn.textContent = 'Generating PDF…';
        if (typeof html2canvas === 'function') {
          var html = buildCollectionHtml(products, collData.title, collData.logo);
          captureCollectionWithHtml2Canvas(html, function (blob) {
            if (blob && blob.size >= 50) {
              onDone(blob);
            } else {
              generateNativeCollectionPdf(products, collData.title, collData.logo, onDone);
            }
          });
        } else {
          generateNativeCollectionPdf(products, collData.title, collData.logo, onDone);
        }
      })
      .catch(function (err) {
        console.error('[hvac-email] collection fetch error:', err);
        onDone(null);
      });
  }

  /* ── simple email message (body of the email) ──────────────── */

  function buildEmailHtml(senderName, viewBtnText, pageTitle, firstName, logoUrl) {
    var btnLabel  = viewBtnText || 'VIEW PRODUCT ONLINE';
    var greeting  = firstName ? 'Hello, ' + esc(firstName) + '!' : 'Hello!';
    var titleRow  = pageTitle
      ? '<tr><td style="padding:0 40px 6px;">' +
          '<p style="margin:0;font-size:13px;font-weight:700;color:#1a3c6e;text-transform:uppercase;letter-spacing:0.05em;">' +
          esc(pageTitle) + '</p></td></tr>'
      : '';
    return (
      '<!DOCTYPE html><html><head><meta charset="utf-8">' +
      '<meta name="viewport" content="width=device-width,initial-scale=1"></head>' +
      '<body style="margin:0;padding:0;background:#e3ebf5;font-family:Arial,Helvetica,sans-serif;">' +
      '<table width="100%" cellpadding="0" cellspacing="0" style="background:#e3ebf5;padding:32px 16px;">' +
        '<tr><td align="center">' +
          '<table width="560" cellpadding="0" cellspacing="0" style="max-width:560px;width:100%;background:#ffffff;border-radius:6px;overflow:hidden;box-shadow:0 2px 10px rgba(0,0,0,0.09);">' +

            /* ── header ── */
            '<tr><td style="' + (logoUrl ? 'background:#ffffff' : 'background:#1a3c6e') + ';padding:18px 40px;">' +
              (logoUrl
                ? '<img src="' + logoUrl + '" alt="HVACMORE" style="max-height:60px;max-width:220px;display:block;">'
                : '<span style="font-family:Arial,sans-serif;font-size:26px;font-weight:900;color:#ffffff;letter-spacing:0.03em;">HVAC<span style="color:#f59e0b;">MORE</span></span>' +
                  '<p style="margin:5px 0 0;font-size:11px;color:rgba(255,255,255,0.65);letter-spacing:0.08em;text-transform:uppercase;">Pay Less, Save More</p>') +
            '</td></tr>' +

            /* ── blue accent bar ── */
            '<tr><td style="height:4px;background:linear-gradient(90deg,#1d4ed8,#3b82f6);"></td></tr>' +

            /* ── body ── */
            '<tr><td style="padding:36px 40px 10px;">' +
              '<p style="margin:0 0 18px;font-size:20px;font-weight:700;color:#111827;line-height:1.3;">' +
                'You\'ve received a product recommendation' +
              '</p>' +
              '<p style="margin:0 0 14px;font-size:15px;color:#374151;line-height:1.7;">' +
                greeting +
              '</p>' +
              '<p style="margin:0 0 14px;font-size:15px;color:#374151;line-height:1.7;">' +
                '<strong style="color:#111827;">HVAC MORE</strong> has shared a product with you ' +
                'from <a href="https://hvacmore.com" style="color:#1a3c6e;font-weight:600;text-decoration:none;">hvacmore.com</a>. ' +
                'The full product details are attached as a PDF to this email.' +
              '</p>' +
              '<p style="margin:0 0 28px;font-size:15px;color:#374151;line-height:1.7;">' +
                'Click the button below to view the product directly on our website.' +
              '</p>' +
              /* ── CTA button ── */
              '<table cellpadding="0" cellspacing="0"><tr>' +
                '<td style="background:#1a3c6e;border-radius:4px;">' +
                  '<a href="' + window.location.href + '" ' +
                    'style="display:inline-block;padding:14px 34px;color:#ffffff;font-family:Arial,sans-serif;' +
                    'font-size:13px;font-weight:700;text-decoration:none;letter-spacing:0.08em;text-transform:uppercase;">' +
                    btnLabel +
                  '</a>' +
                '</td>' +
              '</tr></table>' +
            '</td></tr>' +

            /* ── product title label (if available) ── */
            titleRow +

            /* ── divider ── */
            '<tr><td style="padding:28px 40px 0;">' +
              '<hr style="border:none;border-top:1px solid #e5e7eb;margin:0;">' +
            '</td></tr>' +

            /* ── footer ── */
            '<tr><td style="padding:20px 40px 28px;">' +
              '<p style="margin:0 0 6px;font-size:12px;color:#9ca3af;line-height:1.6;">' +
                'This is an official email from HVACMORE. ' +
                'If you believe this was sent in error, you may disregard this message.' +
              '</p>' +
              '<p style="margin:0;font-size:12px;color:#9ca3af;">' +
                '<a href="https://hvacmore.com" style="color:#9ca3af;text-decoration:none;">hvacmore.com</a>' +
                '&nbsp;&nbsp;|&nbsp;&nbsp;' +
                '<a href="tel:8555754822" style="color:#9ca3af;text-decoration:none;">855-575-4822</a>' +
              '</p>' +
            '</td></tr>' +

          '</table>' +
        '</td></tr>' +
      '</table>' +
      '</body></html>'
    );
  }

  /* ── PDF content (same layout as PRINT button) ─────────────── */

  function buildPdfContent(d) {
    var specsHtml = getSpecsHtml(d);

    var imgCell = d && d.image
      ? '<td width="168" valign="top" style="padding-right:18px;">' +
          '<img src="' + d.image + '" style="width:160px;height:160px;object-fit:contain;border:1px solid #e5e7eb;padding:4px;" crossorigin="anonymous">' +
        '</td>'
      : '';

    var skuRows = d && d.sku
      ? '<p style="font-size:12px;margin:0 0 3px;"><b>MFG Part:</b> ' + esc(d.sku) + '</p>' +
        '<p style="font-size:12px;margin:0 0 8px;"><b>PART:</b> ' + esc(d.sku) + '</p>'
      : '';

    var descBlock = d && d.description
      ? '<hr style="border:none;border-top:1px solid #ccc;margin:14px 0;">' +
        '<h2 style="font-size:12px;font-weight:700;text-transform:uppercase;color:#1a3c6e;margin:0 0 8px;">Product Features</h2>' +
        '<div style="font-size:12px;line-height:1.7;">' + d.description + '</div>'
      : '';

    var specsBlock = specsHtml
      ? '<hr style="border:none;border-top:1px solid #ccc;margin:14px 0;">' +
        '<h2 style="font-size:12px;font-weight:700;text-transform:uppercase;color:#1a3c6e;margin:0 0 8px;">Product Specifications</h2>' +
        '<div style="font-size:11px;">' + specsHtml + '</div>'
      : '';

    return (
      '<style>' +
        '*{box-sizing:border-box;margin:0;padding:0}' +
        'table{border-collapse:collapse}' +
        'th,td{padding:5px 8px;border-bottom:1px solid #d1d5db;font-size:11px;vertical-align:top;text-align:left}' +
        'thead th{background:#e3ebf5;font-weight:700;border-bottom:2px solid #c0c4cb}' +
        'tr:last-child td{border-bottom:none}' +
      '</style>' +
      '<div style="font-family:Arial,sans-serif;font-size:12px;color:#111;">' +
        (d && d.logo ? '<img src="' + d.logo + '" style="max-height:50px;display:block;margin-bottom:14px;" crossorigin="anonymous">' : '') +
        '<hr style="border:none;border-top:2px solid #1a3c6e;margin:0 0 14px;">' +
        '<table width="100%" cellpadding="0" cellspacing="0" style="margin-bottom:12px;">' +
          '<tr>' +
            imgCell +
            '<td valign="top">' +
              (d && d.vendor ? '<p style="font-size:11px;color:#1a3c6e;font-weight:700;text-transform:uppercase;margin-bottom:4px;">' + esc(d.vendor) + '</p>' : '') +
              '<h1 style="font-size:16px;font-weight:700;text-transform:uppercase;margin-bottom:10px;line-height:1.25;">' + esc(d && d.title) + '</h1>' +
              skuRows +
              (d && d.price ? '<p style="font-size:20px;font-weight:700;color:#1a3c6e;">' + esc(d.price) + '</p>' : '') +
            '</td>' +
          '</tr>' +
        '</table>' +
        '<p style="font-size:12px;font-weight:600;margin-bottom:14px;">&#x1F69A; Free Shipping &nbsp;&nbsp; &#x1F4B2; Price Match &nbsp;&nbsp; &#x1F4C5; Ships 1-2 Business Days &nbsp;&nbsp; &#x1F3E0; Delivers 1-5 Business Days</p>' +
        descBlock +
        specsBlock +
      '</div>'
    );
  }

  /* ── PDF entry point: html2canvas path (matches print button exactly),
         falls back to native vector PDF if html2canvas not loaded ─── */

  function generatePdf(d, onDone) {
    if (typeof html2canvas === 'function' && typeof window.hvacBuildPrint === 'function') {
      captureWithHtml2Canvas(d, onDone);
    } else {
      generateNativePdf(d, onDone);
    }
  }

  /* capture the same HTML the print button uses, slice into pages */
  function captureWithHtml2Canvas(d, onDone) {
    try {
      var PW = 816, PH = 1056; /* US-letter px at 96 dpi */

      /* build print HTML and strip the auto-print <script> */
      var printHtml = window.hvacBuildPrint(d)
        .replace(/<script[\s\S]*?<\/script>/gi, '');

      /* hidden off-screen iframe */
      var iframe = document.createElement('iframe');
      iframe.style.cssText = 'position:fixed;left:-9999px;top:-9999px;width:' + PW + 'px;height:' + PH + 'px;border:none;';
      document.body.appendChild(iframe);

      var h2cDone = false;
      var h2cTimeout = setTimeout(function() {
        if (!h2cDone) {
          h2cDone = true;
          try { document.body.removeChild(iframe); } catch(e) {}
          generateNativePdf(d, onDone);
        }
      }, 12000);

      iframe.onload = function () {
        /* wait for images inside the iframe to finish loading */
        setTimeout(function () {
          if (h2cDone) return;
          var iBody = iframe.contentDocument.body;
          var totalH = Math.max(iBody.scrollHeight, PH);
          iframe.style.height = totalH + 'px';

          html2canvas(iBody, {
            width: PW,
            height: totalH,
            windowWidth: PW,
            windowHeight: totalH,
            useCORS: true,
            allowTaint: false,
            scale: 1,
            logging: false,
            backgroundColor: '#ffffff'
          }).then(function (canvas) {
            if (h2cDone) return;
            h2cDone = true;
            clearTimeout(h2cTimeout);
            document.body.removeChild(iframe);

            /* slice canvas into US-letter pages */
            var numPages = Math.ceil(totalH / PH);
            var jpegs = new Array(numPages);
            var done = 0;

            for (var pi = 0; pi < numPages; pi++) {
              (function (idx) {
                var pc = document.createElement('canvas');
                pc.width = PW; pc.height = PH;
                var ctx = pc.getContext('2d');
                ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, PW, PH);
                ctx.drawImage(canvas, 0, idx * PH, PW, PH, 0, 0, PW, PH);
                var b64 = pc.toDataURL('image/jpeg', 0.92).split(',')[1];
                var bin = atob(b64);
                var bytes = new Uint8Array(bin.length);
                for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
                jpegs[idx] = { b: bytes, w: PW, h: PH };
                if (++done === numPages) buildImagePdf(jpegs, onDone);
              })(pi);
            }
          }).catch(function (err) {
            if (h2cDone) return;
            h2cDone = true;
            clearTimeout(h2cTimeout);
            console.error('[hvac-email] html2canvas error:', err);
            document.body.removeChild(iframe);
            generateNativePdf(d, onDone);
          });
        }, 1000); /* 1 s for images inside iframe to load */
      };

      var iDoc = iframe.contentDocument || iframe.contentWindow.document;
      iDoc.open(); iDoc.write(printHtml); iDoc.close();

    } catch (e) {
      console.error('[hvac-email] capture error:', e);
      generateNativePdf(d, onDone);
    }
  }

  /* build a multi-page PDF where every page is a full-page JPEG */
  function buildImagePdf(jpegs, onDone) {
    try {
      function strToBytes(s) {
        var b = new Uint8Array(s.length);
        for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 0xFF;
        return b;
      }
      var parts = [], pos = 0, offs = {};
      function ps(s) { var b = strToBytes(s); parts.push(b); pos += b.length; }
      function pb(b) { parts.push(b); pos += b.length; }
      function ad(n, dict) { offs[n] = pos; ps(n + ' 0 obj\n' + dict + '\nendobj\n'); }
      function as(n, dict, buf) { offs[n] = pos; ps(n + ' 0 obj\n' + dict + '\nstream\n'); pb(buf); ps('\nendstream\nendobj\n'); }

      /* 3 objects per page: Page, ContentStream, ImageXObject */
      var NP = jpegs.length;
      var W = 612, H = 792; /* US-letter in pt (8.5" × 11") */
      var firstPageN = 3;
      var numObjs = 2 + NP * 3;

      ps('%PDF-1.4\n');
      ad(1, '<< /Type /Catalog /Pages 2 0 R >>');

      var kids = [];
      for (var i = 0; i < NP; i++) kids.push((firstPageN + i * 3) + ' 0 R');
      ad(2, '<< /Type /Pages /Kids [' + kids.join(' ') + '] /Count ' + NP + ' >>');

      for (var pi = 0; pi < NP; pi++) {
        var pN = firstPageN + pi * 3;
        var cN = pN + 1, iN = pN + 2;
        var pg = jpegs[pi];
        var csB = strToBytes('q\n' + W + ' 0 0 ' + H + ' 0 0 cm\n/Im1 Do\nQ');
        ad(pN, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + W + ' ' + H + '] /Contents ' + cN + ' 0 R /Resources << /XObject << /Im1 ' + iN + ' 0 R >> >> >>');
        as(cN, '<< /Length ' + csB.length + ' >>', csB);
        as(iN, '<< /Type /XObject /Subtype /Image /Width ' + pg.w + ' /Height ' + pg.h + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + pg.b.length + ' >>', pg.b);
      }

      var xp = pos;
      ps('xref\n0 ' + (numObjs + 1) + '\n0000000000 65535 f \n');
      for (var n = 1; n <= numObjs; n++) {
        var o = String(offs[n]); while (o.length < 10) o = '0' + o; ps(o + ' 00000 n \n');
      }
      ps('trailer\n<< /Size ' + (numObjs + 1) + ' /Root 1 0 R >>\nstartxref\n' + xp + '\n%%EOF');

      var total = 0;
      for (var j = 0; j < parts.length; j++) total += parts[j].length;
      var res = new Uint8Array(total), of2 = 0;
      for (var j2 = 0; j2 < parts.length; j2++) { res.set(parts[j2], of2); of2 += parts[j2].length; }

      onDone(new Blob([res], { type: 'application/pdf' }));
    } catch (e) {
      console.error('[hvac-email] image PDF build error:', e);
      onDone(null);
    }
  }

  /* ── native (vector) PDF fallback ──────────────────────────────── */

  function generateNativePdf(d, onDone) {

    function ps(s) {
      return (s || '').replace(/[^\x20-\x7E]/g, '-')
                      .replace(/\\/g, '\\\\').replace(/\(/g, '\\(').replace(/\)/g, '\\)');
    }
    function wrap(text, max) {
      var words = (text || '').split(' '), lines = [], line = '';
      for (var wi = 0; wi < words.length; wi++) {
        var w = words[wi]; if (!w) continue;
        if (line && (line + ' ' + w).length > max) { lines.push(line); line = w; }
        else { line = line ? line + ' ' + w : w; }
      }
      if (line) lines.push(line);
      return lines.length ? lines : [''];
    }
    function strToBytes(s) {
      var b = new Uint8Array(s.length);
      for (var i = 0; i < s.length; i++) b[i] = s.charCodeAt(i) & 0xFF;
      return b;
    }

    /* fetch one image → JPEG Uint8Array */
    function fetchImg(url, maxW, maxH, squareCrop, cb) {
      try {
        var img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = function () {
          try {
            var sw = img.naturalWidth, sh = img.naturalHeight, dw, dh, ox = 0, oy = 0, sw2 = sw, sh2 = sh;
            if (squareCrop) {
              var s = Math.min(sw, sh); ox = (sw - s) / 2; oy = (sh - s) / 2; sw2 = sh2 = s;
              dw = dh = Math.min(maxW, maxH);
            } else {
              var r = Math.min(maxW / sw, maxH / sh, 1);
              dw = Math.max(1, Math.round(sw * r)); dh = Math.max(1, Math.round(sh * r));
            }
            var cv = document.createElement('canvas'); cv.width = dw; cv.height = dh;
            var ctx = cv.getContext('2d');
            ctx.fillStyle = '#ffffff'; ctx.fillRect(0, 0, dw, dh);
            ctx.drawImage(img, ox, oy, sw2, sh2, 0, 0, dw, dh);
            var bin = atob(cv.toDataURL('image/jpeg', 0.92).split(',')[1]);
            var bytes = new Uint8Array(bin.length);
            for (var i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
            cb(bytes, dw, dh);
          } catch (e) { cb(null, 0, 0); }
        };
        img.onerror = function () { cb(null, 0, 0); };
        img.src = url;
      } catch (e) { cb(null, 0, 0); }
    }

    /* rich HTML → PDF content-stream ops, returns new y */
    function renderDescHtml(htmlStr, cs, ml, mr, startY) {
      var y = startY;
      var div = document.createElement('div');
      div.innerHTML = htmlStr;

      function wc(sz) { return Math.max(20, Math.floor((mr - ml) / (sz * 0.52))); }

      function nodes(list, bold, sz, indent) {
        for (var ni = 0; ni < list.length; ni++) {
          if (y <= 80) return;
          var node = list[ni];
          var tag  = (node.nodeName || '').toLowerCase();
          if (node.nodeType === 3) {
            var txt = node.textContent.replace(/\s+/g, ' ').trim(); if (!txt) continue;
            cs.push('0 0 0 rg');
            wrap(txt, wc(sz) - Math.round(indent / (sz * 0.52))).forEach(function (ln) {
              if (y <= 80) return;
              cs.push('BT ' + (bold ? '/F2' : '/F1') + ' ' + sz + ' Tf ' + (ml + indent) + ' ' + y + ' Td (' + ps(ln) + ') Tj ET');
              y -= (sz + 3);
            });
          } else if (tag === 'h1') {
            var t = node.textContent.replace(/\s+/g, ' ').trim(); if (!t) continue;
            y -= 4;
            wrap(t, wc(13)).forEach(function (ln) { if (y <= 80) return; cs.push('0 0 0 rg'); cs.push('BT /F2 13 Tf ' + (ml + indent) + ' ' + y + ' Td (' + ps(ln) + ') Tj ET'); y -= 17; });
            y -= 3;
          } else if (tag === 'h2') {
            var t = node.textContent.replace(/\s+/g, ' ').trim(); if (!t) continue;
            y -= 3;
            wrap(t, wc(11)).forEach(function (ln) { if (y <= 80) return; cs.push('0 0 0 rg'); cs.push('BT /F2 11 Tf ' + (ml + indent) + ' ' + y + ' Td (' + ps(ln) + ') Tj ET'); y -= 15; });
            y -= 2;
          } else if (tag === 'h3' || tag === 'h4' || tag === 'h5' || tag === 'h6') {
            var t = node.textContent.replace(/\s+/g, ' ').trim(); if (!t) continue;
            y -= 2; cs.push('0 0 0 rg');
            cs.push('BT /F2 9 Tf ' + (ml + indent) + ' ' + y + ' Td (' + ps(t) + ') Tj ET'); y -= 13;
          } else if (tag === 'p') {
            nodes(Array.from(node.childNodes), bold, sz, indent); y -= 4;
          } else if (tag === 'div') {
            nodes(Array.from(node.childNodes), bold, sz, indent);
          } else if (tag === 'strong' || tag === 'b') {
            nodes(Array.from(node.childNodes), true, sz, indent);
          } else if (tag === 'em' || tag === 'i' || tag === 'span' || tag === 'a') {
            nodes(Array.from(node.childNodes), bold, sz, indent);
          } else if (tag === 'ul' || tag === 'ol') {
            var items = Array.from(node.querySelectorAll('li'));
            items.forEach(function (li) {
              if (y <= 80) return;
              var itxt = li.textContent.replace(/\s+/g, ' ').trim();
              wrap(itxt, wc(sz) - Math.round((indent + 12) / (sz * 0.52))).forEach(function (ln, lni) {
                if (y <= 80) return;
                cs.push('0 0 0 rg');
                cs.push('BT /F1 ' + sz + ' Tf ' + (ml + indent + (lni === 0 ? 3 : 15)) + ' ' + y + ' Td (' + (lni === 0 ? '- ' : '') + ps(ln) + ') Tj ET');
                y -= (sz + 3);
              });
            });
            y -= 3;
          } else if (tag === 'br') {
            y -= sz;
          } else if (tag === 'hr') {
            cs.push('0.78 0.78 0.78 RG 0.3 w'); cs.push(ml + ' ' + y + ' m ' + mr + ' ' + y + ' l S'); cs.push('0 0 0 RG'); y -= 10;
          } else if (tag !== 'style' && tag !== 'script') {
            nodes(Array.from(node.childNodes), bold, sz, indent);
          }
        }
      }

      nodes(Array.from(div.childNodes), false, 9, 0);
      return y;
    }

    /* spec tables in 3-column layout, returns new y */
    function renderSpecsCols(specsHtml, cs, ml, mr, startY) {
      var tmp = document.createElement('div'); tmp.innerHTML = specsHtml;
      var tables = Array.from(tmp.querySelectorAll('table'));
      if (!tables.length) return startY;
      var NC = 3, gap = 10;
      var cw = Math.floor((mr - ml - (NC - 1) * gap) / NC);
      var cxs = [ml, ml + cw + gap, ml + 2 * (cw + gap)];
      var hw = Math.floor(cw * 0.47);

      function tblH(tbl) { return (tbl.querySelector('thead') ? 16 : 0) + tbl.querySelectorAll('tbody tr').length * 13 + 8; }

      var cols = [[], [], []], hs = [0, 0, 0];
      tables.forEach(function (tbl) {
        var h = tblH(tbl), min = 0;
        if (hs[1] < hs[min]) min = 1; if (hs[2] < hs[min]) min = 2;
        cols[min].push(tbl); hs[min] += h;
      });

      var y = startY, endY = y;
      for (var ci = 0; ci < NC; ci++) {
        var cx = cxs[ci], cy = y, ri = 0;
        cols[ci].forEach(function (tbl) {
          if (cy <= 80) return;
          var hd = tbl.querySelector('thead th');
          if (hd) {
            var hdT = hd.textContent.replace(/[^\x20-\x7E]/g, '').trim();
            cs.push('0.216 0.314 0.541 rg'); cs.push(cx + ' ' + (cy - 3) + ' ' + cw + ' 15 re f');
            cs.push('1 1 1 rg'); cs.push('BT /F2 7.5 Tf ' + (cx + 3) + ' ' + cy + ' Td (' + ps(hdT) + ') Tj ET');
            cs.push('0 0 0 rg'); cy -= 16;
          }
          tbl.querySelectorAll('tbody tr').forEach(function (row) {
            if (cy <= 80) return;
            var cells = row.querySelectorAll('td'); if (cells.length < 2) return;
            var k = cells[0].textContent.replace(/[^\x20-\x7E]/g, '-').trim();
            var v = cells[1].textContent.replace(/[^\x20-\x7E]/g, '-').trim();
            var kls = wrap(k, Math.floor(hw / 4.3)), vls = wrap(v, Math.floor(hw / 4.3));
            var rh = Math.max(kls.length, vls.length) * 10 + 3;
            if (ri % 2 === 0) { cs.push('0.961 0.969 0.980 rg'); cs.push(cx + ' ' + (cy - rh + 10) + ' ' + cw + ' ' + rh + ' re f'); }
            cs.push('0.102 0.235 0.431 rg');
            kls.forEach(function (kl, ki) { if (cy - ki * 10 > 80) cs.push('BT /F2 7 Tf ' + (cx + 2) + ' ' + (cy - ki * 10) + ' Td (' + ps(kl) + ') Tj ET'); });
            cs.push('0.067 0.067 0.067 rg');
            vls.forEach(function (vl, vi) { if (cy - vi * 10 > 80) cs.push('BT /F1 7 Tf ' + (cx + hw + 3) + ' ' + (cy - vi * 10) + ' Td (' + ps(vl) + ') Tj ET'); });
            cs.push('0.82 0.82 0.82 RG 0.2 w'); cs.push(cx + ' ' + (cy - rh + 7) + ' m ' + (cx + cw) + ' ' + (cy - rh + 7) + ' l S');
            cs.push('0 0 0 RG 0 0 0 rg'); cy -= rh; ri++;
          });
          cy -= 8;
        });
        if (cy < endY) endY = cy;
      }
      return endY;
    }

    /* build PDF binary */
    function doGenerate(logoB, logoW, logoH, prodB, prodW, prodH) {
      try {
        var W = 595, H = 842, ml = 50, mr = 545;
        var hasLogo = !!(logoB && logoB.length);
        var hasImg  = !!(prodB && prodB.length);
        var pdw = 120, pdh = 120;

        var cs = [];

        /* header */
        if (hasLogo) {
          cs.push('1 1 1 rg'); cs.push('0 ' + (H - 55) + ' ' + W + ' 55 re f');
          var lDH = Math.min(48, Math.round(logoH * 180 / Math.max(logoW, 1)));
          var lDW = Math.round(logoW * lDH / Math.max(logoH, 1));
          var lY  = H - 55 + Math.round((55 - lDH) / 2);
          cs.push('q'); cs.push(lDW + ' 0 0 ' + lDH + ' ' + ml + ' ' + lY + ' cm'); cs.push('/Lo1 Do'); cs.push('Q');
          cs.push('0.102 0.235 0.431 RG 1.5 w'); cs.push('0 ' + (H - 55) + ' m ' + W + ' ' + (H - 55) + ' l S'); cs.push('0 0 0 RG 1 w');
        } else {
          cs.push('0.102 0.235 0.431 rg'); cs.push('0 ' + (H - 52) + ' ' + W + ' 52 re f');
          cs.push('1 1 1 rg'); cs.push('BT /F2 14 Tf ' + ml + ' ' + (H - 32) + ' Td (HVACMORE) Tj ET');
        }

        var y = H - 70;
        cs.push('0.102 0.235 0.431 RG 0.5 w'); cs.push(ml + ' ' + y + ' m ' + mr + ' ' + y + ' l S'); cs.push('0 0 0 RG 1 w');
        y -= 18;

        var imgY = H - 70 - pdh;
        if (hasImg) {
          cs.push('q'); cs.push(pdw + ' 0 0 ' + pdh + ' ' + ml + ' ' + imgY + ' cm'); cs.push('/Im1 Do'); cs.push('Q');
        }

        var txtX = hasImg ? (ml + pdw + 15) : ml;

        if (d && d.vendor) {
          cs.push('0.102 0.235 0.431 rg');
          cs.push('BT /F2 9 Tf ' + txtX + ' ' + y + ' Td (' + ps(d.vendor.toUpperCase()) + ') Tj ET'); y -= 14;
        }
        if (d && d.title) {
          cs.push('0 0 0 rg');
          wrap(d.title.toUpperCase(), hasImg ? 50 : 62).forEach(function (ln) {
            if (y <= 80) return; cs.push('BT /F2 13 Tf ' + txtX + ' ' + y + ' Td (' + ps(ln) + ') Tj ET'); y -= 18;
          }); y -= 2;
        }
        if (d && d.vendor) {
          cs.push('0 0 0 rg'); cs.push('BT /F1 9 Tf ' + txtX + ' ' + y + ' Td (Brand: ' + ps(d.vendor) + ') Tj ET'); y -= 13;
        }
        if (d && d.sku) {
          cs.push('0.216 0.255 0.318 rg'); cs.push('BT /F1 8 Tf ' + txtX + ' ' + y + ' Td (MFG Part: ' + ps(d.sku) + ') Tj ET'); y -= 12;
        }
        if (d && d.price) {
          cs.push('0.102 0.235 0.431 rg'); cs.push('BT /F2 16 Tf ' + txtX + ' ' + y + ' Td (' + ps(d.price) + ') Tj ET'); y -= 22;
        }

        if (hasImg && y > imgY - 8) y = imgY - 8;

        /* perks row — truck / dollar / calendar / house icons drawn with PDF paths */
        (function () {
          var perks = [
            { lbl: 'Free Shipping',              ico: 'truck'    },
            { lbl: 'Price Match',                ico: 'dollar'   },
            { lbl: 'Ships 1-2 Business Days',    ico: 'calendar' },
            { lbl: 'Delivers 1-5 Business Days', ico: 'house'    }
          ];
          var slot = 16, gap = 12, px = ml;
          perks.forEach(function (p) {
            var ix = px, iy = y - 2;
            cs.push('0.102 0.235 0.431 rg');
            if (p.ico === 'truck') {
              cs.push(ix + ' ' + (iy + 3) + ' 9 6 re f');                    /* trailer */
              cs.push((ix + 9) + ' ' + iy + ' 5 8 re f');                     /* cab */
              cs.push('1 1 1 rg');
              cs.push((ix + 10) + ' ' + (iy + 4) + ' 3 3 re f');             /* windshield */
              cs.push('0.22 0.22 0.22 rg');
              cs.push((ix + 1) + ' ' + iy + ' 3 3 re f');                     /* wheel L */
              cs.push((ix + 10) + ' ' + iy + ' 3 3 re f');                    /* wheel R */
            } else if (p.ico === 'dollar') {
              /* octagon (circle approximation) */
              cs.push((ix + 6) + ' ' + (iy + 12) + ' m '
                + (ix + 10) + ' ' + (iy + 11) + ' l '
                + (ix + 12) + ' ' + (iy + 7)  + ' l '
                + (ix + 11) + ' ' + (iy + 3)  + ' l '
                + (ix + 7)  + ' ' + iy         + ' l '
                + (ix + 3)  + ' ' + (iy + 1)  + ' l '
                + (ix + 1)  + ' ' + (iy + 5)  + ' l '
                + (ix + 2)  + ' ' + (iy + 9)  + ' l h f');
              cs.push('1 1 1 rg');
              cs.push('BT /F2 9 Tf ' + (ix + 4) + ' ' + (iy + 3) + ' Td ($) Tj ET');
            } else if (p.ico === 'calendar') {
              cs.push(ix + ' ' + iy + ' 12 11 re f');                        /* body */
              cs.push('1 1 1 rg');
              cs.push(ix + ' ' + (iy + 8) + ' 12 3 re f');                   /* header stripe */
              cs.push('0.102 0.235 0.431 rg');
              cs.push((ix + 3) + ' ' + (iy + 9) + ' 2 3 re f');              /* binding tab L */
              cs.push((ix + 7) + ' ' + (iy + 9) + ' 2 3 re f');              /* binding tab R */
              cs.push('1 1 1 rg');
              [0, 1].forEach(function (r) {
                [0, 1, 2].forEach(function (ci) {
                  cs.push((ix + 1 + ci * 4) + ' ' + (iy + 1 + r * 3) + ' 3 2 re f'); /* day grid */
                });
              });
            } else { /* house */
              cs.push(ix + ' ' + iy + ' 12 7 re f');                         /* base */
              cs.push(ix + ' ' + (iy + 7) + ' m '
                + (ix + 6)  + ' ' + (iy + 12) + ' l '
                + (ix + 12) + ' ' + (iy + 7)  + ' l h f');                   /* roof */
              cs.push('1 1 1 rg');
              cs.push((ix + 4.5) + ' ' + iy + ' 3 4.5 re f');                /* door */
            }
            cs.push('0.216 0.255 0.318 rg');
            cs.push('BT /F2 8 Tf ' + (px + slot) + ' ' + y + ' Td (' + ps(p.lbl) + ') Tj ET');
            px += slot + Math.round(p.lbl.length * 4.4) + gap;
          });
        })();
        y -= 14;
        cs.push('0.102 0.235 0.431 RG 0.5 w'); cs.push(ml + ' ' + y + ' m ' + mr + ' ' + y + ' l S'); cs.push('0 0 0 RG 1 w'); y -= 16;

        if (d && d.description) {
          cs.push('0.102 0.235 0.431 rg'); cs.push('BT /F2 10 Tf ' + ml + ' ' + y + ' Td (PRODUCT FEATURES) Tj ET'); y -= 15;
          y = renderDescHtml(d.description, cs, ml, mr, y);
          y -= 5;
          cs.push('0.102 0.235 0.431 RG 0.5 w'); cs.push(ml + ' ' + y + ' m ' + mr + ' ' + y + ' l S'); cs.push('0 0 0 RG 1 w'); y -= 16;
        }

        var specsHtml = getSpecsHtml(d);
        if (specsHtml && y > 80) {
          cs.push('0.102 0.235 0.431 rg'); cs.push('BT /F2 10 Tf ' + ml + ' ' + y + ' Td (PRODUCT SPECIFICATIONS) Tj ET'); y -= 15;
          y = renderSpecsCols(specsHtml, cs, ml, mr, y);
        }

        var footUrl = 'hvacmore.com  |  ' + window.location.href;
        if (footUrl.length > 90) footUrl = footUrl.substring(0, 87) + '...';
        cs.push('0.42 0.45 0.50 rg'); cs.push('BT /F1 7 Tf ' + ml + ' 22 Td (' + ps(footUrl) + ') Tj ET');

        var contentBytes = strToBytes(cs.join('\n'));
        var parts = [], pos = 0, offsets = {};

        function pushStr(s) { var b = strToBytes(s); parts.push(b); pos += b.length; }
        function pushBuf(b) { parts.push(b); pos += b.length; }
        function addDict(n, dict) { offsets[n] = pos; pushStr(n + ' 0 obj\n' + dict + '\nendobj\n'); }
        function addStream(n, dict, buf) { offsets[n] = pos; pushStr(n + ' 0 obj\n' + dict + '\nstream\n'); pushBuf(buf); pushStr('\nendstream\nendobj\n'); }

        var nextN = 7, im1N = 0, lo1N = 0;
        if (hasImg)  { im1N = nextN++; }
        if (hasLogo) { lo1N = nextN++; }
        var numObjs = nextN - 1;

        pushStr('%PDF-1.4\n');
        addDict(1, '<< /Type /Catalog /Pages 2 0 R >>');
        addDict(2, '<< /Type /Pages /Kids [3 0 R] /Count 1 >>');
        var xobjs = (im1N ? '/Im1 ' + im1N + ' 0 R ' : '') + (lo1N ? '/Lo1 ' + lo1N + ' 0 R' : '');
        var rsrc  = '/Font << /F1 5 0 R /F2 6 0 R >>' + (xobjs.trim() ? ' /XObject << ' + xobjs.trim() + ' >>' : '');
        addDict(3, '<< /Type /Page /Parent 2 0 R /MediaBox [0 0 ' + W + ' ' + H + '] /Contents 4 0 R /Resources << ' + rsrc + ' >> >>');
        addStream(4, '<< /Length ' + contentBytes.length + ' >>', contentBytes);
        addDict(5, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica /Encoding /WinAnsiEncoding >>');
        addDict(6, '<< /Type /Font /Subtype /Type1 /BaseFont /Helvetica-Bold /Encoding /WinAnsiEncoding >>');
        if (im1N) addStream(im1N, '<< /Type /XObject /Subtype /Image /Width ' + prodW + ' /Height ' + prodH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + prodB.length + ' >>', prodB);
        if (lo1N) addStream(lo1N, '<< /Type /XObject /Subtype /Image /Width ' + logoW + ' /Height ' + logoH + ' /ColorSpace /DeviceRGB /BitsPerComponent 8 /Filter /DCTDecode /Length ' + logoB.length + ' >>', logoB);

        var xrefPos = pos;
        pushStr('xref\n0 ' + (numObjs + 1) + '\n0000000000 65535 f \n');
        for (var n = 1; n <= numObjs; n++) {
          var off = String(offsets[n]); while (off.length < 10) off = '0' + off; pushStr(off + ' 00000 n \n');
        }
        pushStr('trailer\n<< /Size ' + (numObjs + 1) + ' /Root 1 0 R >>\nstartxref\n' + xrefPos + '\n%%EOF');

        var total = 0;
        for (var pi = 0; pi < parts.length; pi++) total += parts[pi].length;
        var result = new Uint8Array(total), ofs = 0;
        for (var pi2 = 0; pi2 < parts.length; pi2++) { result.set(parts[pi2], ofs); ofs += parts[pi2].length; }

        onDone(new Blob([result], { type: 'application/pdf' }));
      } catch (err) {
        console.error('[hvac-email] PDF build error:', err);
        onDone(null);
      }
    }

    /* parallel-fetch logo + product image, then build */
    var pending = 0, logoB = null, logoW = 0, logoH = 0, prodB = null, prodW = 0, prodH = 0;
    function check() { if (--pending === 0) doGenerate(logoB, logoW, logoH, prodB, prodW, prodH); }
    if (d && d.logo)  { pending++; fetchImg(d.logo,  600, 150, false, function (b, w, h) { logoB = b; logoW = w; logoH = h; check(); }); }
    if (d && d.image) { pending++; fetchImg(d.image, 320, 320, true,  function (b, w, h) { prodB = b; prodW = w; prodH = h; check(); }); }
    if (!pending) doGenerate(null, 0, 0, null, 0, 0);
  }

  /* ── form submit ────────────────────────────────────────────── */

  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    errorMsg.style.display = 'none';
    errorMsg.textContent   = '';

    var firstName = document.getElementById('hvac-email-first').value.trim();
    var lastName  = document.getElementById('hvac-email-last').value.trim();
    var toRaw     = document.getElementById('hvac-email-to').value.trim();
    var ccRawEl   = document.getElementById('hvac-email-cc');
    var ccRaw     = ccRawEl ? ccRawEl.value.trim() : '';

    if (!firstName || !lastName || !toRaw) {
      errorMsg.textContent = 'Please fill in all required fields.';
      errorMsg.style.display = 'block';
      return;
    }

    var emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    var emails   = toRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
    var invalid  = emails.filter(function (em) { return !emailRegex.test(em); });

    if (invalid.length) {
      errorMsg.textContent = 'Please enter valid email address(es).';
      errorMsg.style.display = 'block';
      return;
    }

    if (emails.length > 10) {
      errorMsg.textContent = 'Maximum 10 email addresses allowed.';
      errorMsg.style.display = 'block';
      return;
    }

    var userCc = ccRaw ? ccRaw.split(',').map(function (s) { return s.trim(); }).filter(Boolean) : [];
    var ccInvalid = userCc.filter(function (em) { return !emailRegex.test(em); });

    if (ccInvalid.length) {
      errorMsg.textContent = 'Please enter valid CC email address(es).';
      errorMsg.style.display = 'block';
      return;
    }

    if (userCc.length > 5) {
      errorMsg.textContent = 'Maximum 5 CC addresses allowed.';
      errorMsg.style.display = 'block';
      return;
    }

    var cfg = document.getElementById('hvac-email-cfg');
    var scriptUrl = cfg && cfg.dataset.webhookUrl;
    var shopCc = (cfg && cfg.dataset.ccEmail) || '';
    var ccList = userCc.slice();
    if (shopCc && ccList.indexOf(shopCc) === -1) ccList.push(shopCc);
    var ccEmail = ccList.join(', ');

    if (!scriptUrl || scriptUrl === 'PASTE_YOUR_MAKE_WEBHOOK_URL_HERE') {
      errorMsg.textContent = 'Email service is not configured. Please contact the store.';
      errorMsg.style.display = 'block';
      return;
    }

    submitBtn.disabled    = true;
    submitBtn.textContent = 'Generating PDF…';

    var senderName   = firstName + ' ' + lastName;
    var isCollection = isCollectionPage();
    var collData     = isCollection ? getCollectionData() : null;
    var d            = isCollection ? null : getProductData();
    var pageTitle    = isCollection ? (collData && collData.title) : (d && d.title);
    var filename     = buildFilename(isCollection, collData, d);
    var subject      = pageTitle
      ? (isCollection
          ? 'HVACMORE — Collection: ' + pageTitle
          : 'HVACMORE — Product Recommendation: ' + pageTitle)
      : (isCollection ? 'HVACMORE Product Catalog'
                      : 'HVACMORE Product Recommendation');
    var viewBtnText  = isCollection ? 'VIEW COLLECTION ONLINE' : 'VIEW PRODUCT ONLINE';
    var logoBtn      = document.querySelector('.hvac-email-open-btn[data-logo]');
    var logoUrl      = (collData && collData.logo) || (logoBtn ? logoBtn.dataset.logo : '');
    if (logoUrl && logoUrl.indexOf('//') === 0) logoUrl = 'https:' + logoUrl;

    function handlePdfBlob(pdfBlob) {
      if (!pdfBlob || pdfBlob.size < 50) {
        submitBtn.disabled    = false;
        submitBtn.textContent = 'SEND EMAIL';
        errorMsg.textContent  = 'PDF generation failed — please refresh the page and try again.';
        errorMsg.style.display = 'block';
        return;
      }

      submitBtn.textContent = 'Sending…';

      var fd = new FormData();
      fd.append('to',        emails.join(', '));
      if (ccEmail) {
        fd.append('cc',      ccEmail);
      }
      fd.append('fromName',  'HVACMORE');
      fd.append('subject',   subject);
      fd.append('emailHtml', buildEmailHtml(senderName, viewBtnText, pageTitle, firstName, logoUrl));
      fd.append('filename',  filename);
      fd.append('pdf', pdfBlob, filename + '.pdf');

      fetch(scriptUrl, { method: 'POST', body: fd })
        .then(function (res) {
          if (res.ok) {
            form.style.display       = 'none';
            successMsg.style.display = 'block';
            successMsg.textContent   = 'Email sent! The recipient(s) should receive it shortly.';
            emailSentForPage = true;
          } else {
            throw new Error('Server error: ' + res.status);
          }
        })
        .catch(function (err) {
          submitBtn.disabled    = false;
          submitBtn.textContent = 'SEND EMAIL';
          errorMsg.textContent  = 'Failed to send email. Please try again.';
          errorMsg.style.display = 'block';
          console.error('Send error:', err);
        });
    }

    var pdfDoneFlag = false;
    var pdfTimeoutId = setTimeout(function() {
      if (!pdfDoneFlag) {
        pdfDoneFlag = true;
        submitBtn.disabled    = false;
        submitBtn.textContent = 'SEND EMAIL';
        errorMsg.textContent  = 'PDF generation timed out. Please try again.';
        errorMsg.style.display = 'block';
      }
    }, 20000);

    function guardedHandlePdfBlob(blob) {
      if (pdfDoneFlag) return;
      pdfDoneFlag = true;
      clearTimeout(pdfTimeoutId);
      handlePdfBlob(blob);
    }

    if (isCollection && collData) {
      generateCollectionPdf(collData, guardedHandlePdfBlob);
    } else {
      generatePdf(d, guardedHandlePdfBlob);
    }
  });

})();
